export const SET_ERROR = 'SET_ERROR';

export const setError = (code, timeStamp) => ({
  type: SET_ERROR,
  payload: {
    code,
    timeStamp,
  },
});
